import { SortOrder } from '@/enums/SortOrder';
import qs from 'qs';
import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';

const initialState: WorkspaceState = {
  all: [],
  selected: null,
};

const getters: GetterTree<WorkspaceState, RootState> = {
  all(state: WorkspaceState): Workspace[] {
    return state.all;
  },
  selected(state: WorkspaceState): Workspace | null {
    return state.selected;
  },
};

const mutations: MutationTree<WorkspaceState> = {
  RESET(state: WorkspaceState) {
    state.all = [];
  },
  SET_MODELS(state: WorkspaceState, payload: Workspace[]) {
    state.all = payload;
  },
  SELECT(state: WorkspaceState, payload: Workspace) {
    state.selected = payload;
  },
};

const resource: string = 'api/workspaces';

const actions: ActionTree<WorkspaceState, RootState> = {
  index({ commit, rootState }, { query = { s: { id: SortOrder.ASC }, per_page: 20 } }: { query?: IndexQuery<Option> }) {
    const queryString = qs.stringify(query);
    return rootState.api
      .get(`${resource}?${queryString}`, { withCredentials: true })
      .then((response: { data: Workspace }) => {
        commit('SET_MODELS', response.data);

        return Promise.resolve(response.data);
      })
      .catch((e: ErrorResponse) => {
        return Promise.reject(e);
      });
  },
  select({ commit, rootState }, { workspace }: { workspace: Workspace }) {
    localStorage.setItem('selected_workspace_id', workspace.id.toString());
    if (workspace.config?.theme_color) {
      document.documentElement.style.setProperty('--color-green', workspace.config?.theme_color);
    }
    commit('SELECT', workspace);
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
